import { render, staticRenderFns } from "./Matriz.vue?vue&type=template&id=51b99c7a&scoped=true&"
import script from "./Matriz.vue?vue&type=script&lang=js&"
export * from "./Matriz.vue?vue&type=script&lang=js&"
import style0 from "./Matriz.vue?vue&type=style&index=0&id=51b99c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b99c7a",
  null
  
)

component.options.__file = "Matriz.vue"
export default component.exports